export default {
  oneParams: {
    title: '開戶表格-個人',
    childrens: [
      {
        title: '開戶表格',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Personal-Account-Opening.pdf'
      },
      {
        title: '(CRS-I (HK)) 個人稅務 居民自我證明表格',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/CRS-Individual-Tax-Self-Certification-Form.pdf'
      }, {
        title: '業務條款及細則',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Business-Terms-and-Conditions.pdf'
      }
    ]
  },
  twoParams: {
    title: '開戶表格-公司',
    childrens: [
      {
        title: '開戶表格 (公司)',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Company-Account-Opening-Form.pdf'
      },
      // {
      //   title: '風險評估表格-公司客戶',
      //   link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Risk-Assessment-Form.pdf'
      // },
      {
        title: '實體稅務居民自我證明表格 (CRS-E (HK))',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Entity-Tax-Self-Certification-Form.pdf'
      },
      {
        title: '控權人稅務居民自我證明表格 (CRS-CP (HK))',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Controlling-Person-Tax-Self-Certification-Form.pdf'
      },
      {
        title: '業務條款及細則',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Business-Terms-and-Conditions.pdf'
      }
    ]
  },
  threeParams: {
    title: '其他表格',
    childrens: [
      // {
      //   title: '中央结算交收指示表格',
      //   link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Ed-Central-robbery-settlement-instruction-form.pdf'
      // },
      {
        title: '取消或停用交易賬戶',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Cancellation-of-authorization-of-account-authorization.pdf'
      },
      // {
      //   title: '客戶查證程序',
      //   link: 'http://download.eddidapp.com/pdf/SC/form/Customer-Verification.pdf'
      // },
      {
        title: '新增或更改個人資料或電郵戶口通訊服務表格',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Account-Communication-Service-Form.pdf'
      },
      {
        title: '提款表格',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Aide-Withdrawal-Form.pdf'
      },
      {
        title: '股票實物存入表格',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Stock-Physical-Deposit-Form.pdf'
      },
      {
        title: '股票實物提取表格',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Stock-Withdrawal.pdf'
      },
      {
        title: '結構性產品風險披露聲明書',
        link: 'http://download.eddidapp.com/pdf/TC/risks-of-structured-products-disclosure-statement.pdf'
      },
      {
        title: '內部轉賬/貨幣兌換申請表格',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/IFTCERForm.pdf'
      }
    ]
  }
}
